const { default: styled } = require('styled-components');

export const RecapDiv = styled.div`
  width: 100%;
  border-radius: 30px;
  background: rgba(45, 45, 45, 0.05);
  border: 1px solid rgba(45, 45, 45, 0.02);
  /* padding: 10px 15px; */
  height: ${(props) => (props.expand ? 'auto' : 0)};
  display: ${(props) => (props.expand ? 'block' : 'none')};
  /* opacity: ${(props) => (props.expand ? 1 : 0)}; */
  transition: 0.5s all ease;
`;

export const LevelExpanded = styled.div`
  /* padding: ${(props) => (props.expand ? '10px' : '0')}; */
  opacity: ${(props) => (props.expand ? '1' : '0')};
  max-height: ${(props) => (props.expand ? '126px' : '0')};
  overflow: scroll;
  border-radius: 0 0 30px 30px;
  transition: all 500ms;
  width: 100%;
  transition: 0.5s all ease;
  background: ${(props) => props.theme.colors.neutral50};
  text-align: center;
  z-index: 1;
`;

export const ExpandedDiv = styled.div`
  padding: 10px 15px;
  justify-content: space-between;
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  /*  */
`;

export const LevelSmallText = styled.p`
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: #b5a8a8;
`;

export const LevelNum = styled.p`
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.01em;
  color: #fefefe;
  span {
    color: #a6f787;
  }
`;

export const Level = styled.div`
  width: 100%;
  height: 63px;
  color: ${(props) => props.theme.colors.neutral900};
  border-radius: ${(props) => (props.expand ? '30px 30px 0 0' : '30px')};

  background: ${(props) =>
    props.isCurrentWeek ? props.theme.colors.secondary100 : 'none'};

  border: 1px solid
    ${(props) =>
      !props.isCurrentWeek ? props.theme.colors.neutral0 : 'transparent'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
  padding: 0 16px;
  transition: 0.5s all ease;
  cursor: pointer;
  z-index: 2;
  img {
    transform: ${(props) => (props.expand ? '' : 'rotate(-90deg)')};
    transition: 0.3s all ease;
  }
`;

export const LevelText = styled.div`
  margin-right: 20px;
  font-size: 13px;
  line-height: 15px;
  /* opacity: 0.7; */
  span {
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
  }
`;

export const LevelTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral50};
`;
